import { InfoCircleOutlined, WarningOutlined } from "@ant-design/icons";
import { Typography } from "antd";
import i18n from "i18next";

import type { TransferableEntity } from "src/app/features/ConfigurationTransfer/types/ConfigurationTransfer";
import { Palette } from "../../../../../core/styles/palette";

const { Text } = Typography;

/**
 * Counts the number of unique dependencies of an entity that have allowed: true in the entities list
 */
const getAllowedValues = (entity: TransferableEntity, entities: TransferableEntity[]): number => {
    const entityMap = new Map(entities.map((e) => [e.tableName, e]));
    const uniqueDependencies = Array.from(new Set(entity.dependencies));
    return uniqueDependencies.filter((depName) => entityMap.get(depName)?.allowed === true).length;
};

/**
 * Renders the title for a tree node with dependency and children indicators
 */
export const renderNodeTitle = (entity: TransferableEntity, isDependency: boolean, entities: TransferableEntity[]): React.ReactNode => {
    const depCount = getAllowedValues(entity, entities);
    const childCount = entity.children.length;

    return (
        <span style={{ userSelect: "none" }}>
            <Text strong={!isDependency} type={isDependency ? "secondary" : undefined}>
                {entity.displayName}
                {isDependency && <Text type="secondary"> (dependency)</Text>}
            </Text>
            {depCount > 0 && !isDependency && (
                // aevi styles
                <Text style={{ marginLeft: 8 }} type="warning">
                    <WarningOutlined />{" "}
                    {depCount === 1
                        ? i18n.t("configurationTransfer.tree.dependencyIndicator", { count: depCount })
                        : i18n.t("configurationTransfer.tree.dependenciesIndicator", { count: depCount })}
                </Text>
            )}
            {childCount > 0 && !isDependency && (
                <Text style={{ marginLeft: 8, color: Palette.Blue }}>
                    <InfoCircleOutlined />{" "}
                    {childCount === 1
                        ? i18n.t("configurationTransfer.tree.childIndicator", { count: childCount })
                        : i18n.t("configurationTransfer.tree.childrenIndicator", { count: childCount })}
                </Text>
            )}
        </span>
    );
};
